const firebaseConfig = {
  apiKey: "AIzaSyB-gD6jElwdF7TvLgQ_qDVd9uXkPgbusU4",
  authDomain: "fresh-store1.firebaseapp.com",
  projectId: "fresh-store1",
  storageBucket: "fresh-store1.appspot.com",
  messagingSenderId: "51942021416",
  appId: "1:51942021416:web:324ac8bf08bb421049d81d"
};
  export default firebaseConfig;